<template>
  <div v-if="me" class="page-container mt-4 height-100">
    <section id="section__documents" class="full height-100">
      <v-layout fill-height column justify-space-between>
        <section>
          <!-- <UpdateMe v-if="!referralCode" /> -->

          <!-- 대리점 고객은 사업자 등록증만 -->
          <template v-if="!referralCode">
            <p class="img-text">
              <img src="@/assets/images/documents/heart_01.png" alt="heart" /> 거의 다 왔어요!
            </p>
            <p class="font--m-4 mb-4">
              간단한 서류 제출로 365일 <br />
              매일 정산 받으세요
            </p>
          </template>
          <template v-else>
            <p class="img-text">사업자등록증을 제출해 주세요</p>
            <p class="font--m-4 mb-4">
              진행 중인 고객님 명의의 사업자등록증을
              <br />제출해 주세요
            </p>
          </template>

          <div v-for="(v, k) in requireDocuments" class="documents-items" :key="k + '_uploader'">
            <v-card class="uploader" :class="{ 'd-none': !v.visible }">
              <v-card-text class="pa-3">
                <DocumentFileUploader
                  :documentKey="k"
                  :label="v.title"
                  :originFilePath="v.originPath"
                  :document.sync="v.file"
                >
                  <template #default>
                    <div class="uploader__img">
                      <img :src="v.image" :alt="v.title" />
                    </div>
                  </template>

                  <template #activator="{ uploader, loading, disabled }">
                    <div class="uploader__btn">
                      <BasicButton
                        :loading="loading"
                        :disabled="disabled"
                        :class="{ available: !disabled, modify: !!v.originPath || !!v.file }"
                        @click="uploader()"
                      >
                        {{ v.title }}
                        <template v-if="!!v.originPath || !!v.file"> 수정하기 </template>

                        <template v-else> 첨부하기 </template>
                      </BasicButton>
                    </div>
                  </template>
                </DocumentFileUploader>
              </v-card-text>
            </v-card>
          </div>
        </section>

        <section class="mt-4">
          <p class="chat-text my-4">
            <img src="@/assets/images/documents/chat-advice_01.png" alt="chat" />
            <span>
              서류 제출이 어려우시면 <br />
              1:1 상담을 요청해주세요
            </span>
          </p>
          <BasicButton :disabled="nextLoading || !hasAll" :loading="nextLoading" @click="next">
            확인
          </BasicButton>
        </section>
      </v-layout>
    </section>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { redirectSignupManage } from '@/util/signupManage'

export default {
  components: {
    DocumentFileUploader: () => import('@/components/documents/DocumentFileUploader.vue'),
    // UpdateMe: () => import('@/components/status/UpdateMe.vue'),
  },
  data() {
    return {
      requireDocuments: {
        businessLicense: {
          title: '사업자등록증',
          file: null,
          originPath: null,
          image: require('@/assets/images/documents/document_01.png'),
          visible: true,
        },
        identification: {
          title: '신분증',
          file: null,
          originPath: null,
          image: require('@/assets/images/documents/idcard_01.png'),
          visible: true,
        },
      },
      documents: null,
      nextLoading: false,
    }
  },
  computed: {
    ...mapState('auth', ['me']),
    ...mapGetters('auth', ['referralCode', 'registerWooriCrowd', 'isNiceCheckApp']),
    ...mapState('contract', {
      contractCurrent: 'current',
    }),
    hasAll() {
      const result = Object.keys(this.requireDocuments).every((rq) => {
        const doc = this.requireDocuments[rq]
        return !!doc.file || !!doc.originPath
      })
      return result
    },
  },
  async created() {
    _meta({
      titles: ['필요서류제출'],
    })
    await this.getDocuments()
  },
  watch: {
    documents(v) {
      for (const k in v) {
        if (this.requireDocuments[k]) {
          this.requireDocuments[k].originPath = v[k]
        }
      }
    },
    referralCode: {
      immediate: true,
      handler(v) {
        if (v) {
          this.requireDocuments.identification.visible = false
        }
      },
    },
  },
  methods: {
    ...mapActions('document', { getStoreDocuments: 'getDocuments' }),
    ...mapActions('contract', ['contractComplete']),
    ...mapActions('auth', ['getMe']),
    async getDocuments() {
      this.documents = await this.getStoreDocuments()
    },

    async next() {
      console.log('****** next 버튼')
      if (this.nextLoading) return

      try {
        this.nextLoading = true
        if (await redirectSignupManage()) {
          return
        }
//        return await this.$router.replace({ name: 'signup/bank/collections' })

        await this.getDocuments() // 도큐먼트 갱신
        console.log('********* 도큐먼트 ver2 ', this.$route.query.next)
        if( this.$route.query.next ) {
          return this.$router.replace(this.$route.query.next)
        }

        return await this.$router.replace('/')
      } finally {
        this.nextLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#section__documents {
  background-color: white;
}

.fill-height,
.height-100 {
  min-height: calc(100vh - 120px);
}

.img-text {
  display: flex;
  align-items: center;

  font-size: 22px;
  font-weight: 900;

  margin-bottom: 8px;

  img {
    width: 30px;
  }
}

.chat-text {
  display: flex;
  align-items: center;

  font-size: 15px;

  margin-top: 15px;
  margin-bottom: 0;

  img {
    width: 30px;
    margin-right: 8px;
  }
}

.documents-items {
  &:not(:last-of-type) {
    margin-bottom: 1.5rem;
  }
}

.uploader {
  background-color: #edf9ff;

  &__img {
    width: 180px;
    text-align: center;

    margin: 0 auto;

    img {
      max-width: 180px;
      object-fit: contain;
    }
  }

  &__btn {
    text-align: center;

    margin-top: 4px;

    :deep(button) {
      width: 80% !important;
      height: 42px !important;

      &.available {
        background-color: #88d6ff !important;

        span {
          color: black !important;
        }

        &.modify {
          background-color: #fadada !important;
        }
      }
    }
  }
}
</style>
